import { useState } from 'react';
import Listicon from '../../../assets/images/listicon.svg';
import './Mini.scss';

const Mini = ({ plans, selectedPlan, handleChangePlan }) => {
    const [planId, setPlanId] = useState(selectedPlan || 0);
    const subscription = plans.find(({ id }) => id === planId);
    const isCurrentPlan = planId === selectedPlan;
    const totalPlans = plans.length;

    return (
        <div className="pricing-mini">

            <div className="row btn-holder">
                {plans.map((plan) => {
                    return (
                        <button onClick={() => setPlanId(plan.id)} className={`btn-plan ff-inter-semibold col-${12 / totalPlans} ${planId === plan.id ? 'active' : ''}`}>
                            <div className="mb-150 fs-200">₹{Math.trunc(plan.price)}<div className="fs-150">{plan.billingCycle}</div></div>
                            <div className="fs-150">{plan.name}</div>
                        </button>
                    );
                })}
            </div>

            <div className="features-holder">
                {subscription && (
                    <div className="pt-200">
                        <strong className="fs-200 d-block text-left ff-inter-bold">{subscription.noOfEntries} Free entries</strong>

                        <ul className='list-reset features fs-150 ff-inter-light lh-200 mt-200 mb-300'>
                            {subscription.features.map(feature => {
                                return (<li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />  {feature} </li>)
                            })}
                        </ul>

                        <a className={`btn-primary ${!isCurrentPlan ? '' : 'op-3 cr-not-allowed'}`} href="javascript:;" onClick={() => !isCurrentPlan && handleChangePlan(subscription)}>
                            {isCurrentPlan ? 'Current Plan' : 'Upgrade'}
                        </a>
                    </div>
                )}
            </div>

        </div>
    )
};
export default Mini;